export default __webpack_public_path__ + "static/details-screen-dcdb499fdf390033d03cbca57c63bcc3.webp";